// Internal server-to-server API registry (admin-web).
//
// BL-617 PR #2: the only entry — `notifications.flush` — was removed when the
// old `scheduled_notifications` engine was decommissioned. The bidder
// token-payment receipt now enqueues directly onto the new `notification_queue`
// (no cross-app flush nudge), so this registry is currently empty. New
// internal routes register their defineAdminRoute() entries here.
export const internal = {};
